import PropTypes from 'prop-types';

export const imageConfig = {
  hero: {
    sizes: [320, 640, 768, 1024, 1280, 1536],
    defaultSize: 1280,
    breakpoints: {
      320: '100vw',
      640: '100vw',
      768: '100vw',
      1024: '100vw',
      1280: '100vw',
      1536: '100vw'
    }
  },
  testimonials: {
    sizes: [75, 150, 300],
    defaultSize: 150,
    mediaQueries: {
      75: '(max-width: 480px)',
      150: '(max-width: 768px)',
      300: '(min-width: 769px)',
    },
    breakpoints: {
      sm: 75,
      md: 150,
      lg: 300,
    },
  },
  tech: {
    sizes: [100, 200],
    defaultSize: 100,
    mediaQueries: {
      100: '(max-width: 768px)',
      200: '(min-width: 769px)',
    },
    breakpoints: {
      sm: 100,
      lg: 200,
    },
  },
  projects: {
    sizes: [400, 800],
    defaultSize: 400,
    mediaQueries: {
      400: '(max-width: 768px)',
      800: '(min-width: 769px)',
    },
    breakpoints: {
      sm: 400,
      lg: 800,
    },
  },
  training: {
    sizes: [100, 200],
    defaultSize: 100,
    mediaQueries: {
      100: '(max-width: 768px)',
      200: '(min-width: 769px)',
    },
    breakpoints: {
      sm: 100,
      lg: 200,
    },
  },
};

const OptimizedImage = ({ src, alt, className, loading = 'lazy', type = 'default' }) => {
  const config = imageConfig[type];

  const generateSrcSet = (format) => {
    return config.sizes
      .map(size => {
        const pathParts = src.split('/');
        const filename = pathParts[pathParts.length - 1];
        const directory = pathParts.slice(0, -1).join('/');
        const baseName = filename.replace(/\.(jpg|jpeg|png|webp)$/i, '');
        return `${directory}/${baseName}-${size}.${format} ${size}w`;
      })
      .join(', ');
  };

  const generateSizes = () => {
    return Object.entries(config.breakpoints)
      .map(([breakpoint, size]) => `(max-width: ${breakpoint}px) ${size}`)
      .join(', ');
  };

  return (
    <picture>
      {/* WebP version */}
      <source
        type="image/webp"
        srcSet={generateSrcSet('webp')}
        sizes={generateSizes()}
      />

      {/* Fallback version */}
      <source
        type="image/jpeg"
        srcSet={generateSrcSet('jpg')}
        sizes={generateSizes()}
      />

      {/* Final fallback image */}
      <img
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    </picture>
  );
};

OptimizedImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf([
    'hero',
    'testimonials',
    'tech',
    'projects',
    'training',
  ]),
  loading: PropTypes.oneOf(['lazy', 'eager']),
};

export default OptimizedImage;
